module.exports = __webpack_public_path__ + "static/media/sort.547917d8.png";